
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[id]/experiences",
      function () {
        return require("private-next-pages/company/[id]/experiences/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[id]/experiences"])
      });
    }
  